export const offices = [
  { label: "Todas", value: "" },
  { label: "Ciudad de México", value: "02" },
  { label: "Guadalajara", value: "15" },
  { label: "Monterrey", value: "03" },
  { label: "León", value: "04" },
];

export const orderByOptions = [
  { value: "relevancia", label: "Relevancia" },
  { value: "RECOMMENDED_SCORE", label: "Productos recomendados" },
  { value: "PRICE_LIST_1_ASC", label: "Precio: Menor a mayor" },
  { value: "PRICE_LIST_1_DESC", label: "Precio: Mayor a menor" },
  { value: "NAME_ASC", label: "A-Z" },
  { value: "NAME_DESC", label: "Z-A" },
];

export const defaultCustomerId = "VENTAS_WEB";
export const publicListPrice = 1;

export const translationsType = {
  PDP_RECOMMENDED: "Productos recomendados",
  PDP_ALTERNATIVES: "Alternativas Similares",
  PDP_ACCESSORIES: "Accesorios Compatibles",
  PDP_UPGRADES: "Versiones Mejoradas",
  PDP_YOU_NEED: "También Podrías Necesitar",
  PDP_FREQUENTLY_BOUGHT: "Comprados Juntos",
};

export const rolesTranslations: Record<string, string> = {
  ROLE_ADMIN: "Administrador",
  ROLE_BACKOFFICE: "Backoffice",
  ROLE_FINANCE: "Finanzas",
  ROLE_MARKETING: "Marketing",
  ROLE_PRICING: "Pricing",
  ROLE_ENGINEERING: "Ingeniería",
  ROLE_SALES: "Ventas",
  ROLE_CUSTOMER: "Cliente",
  ROLE_EDITOR: "Editor",
  ROLE_MANAGER: "Gerente",
  ROLE_SUPPLIER: "Proveedor",
  ROLE_INTEGRATOR: "Integrador",
  ROLE_INTEGRADOR: "Integrador",
  ROLE_COMMERCIAL: "Comercial",
  ROLE_SYSTEMS: "Sistemas",
  ROLE_LOGISTICS: "Logística",
};
